// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"d3169b57","114":"5c375e1a","393":"effd48f2","574":"412ce79f","604":"45086af2","628":"39451734","660":"e964f243","809":"98f12dee","921":"d1dfb8db","924":"f4ca3d77","928":"a5df8ff1"}[chunkId] + ".chunk.js";
};